import React from 'react';
import { Tag } from 'antd';

interface OrderStatusProps {
  status: string;
}

const OrderTypeRender: React.FC<OrderStatusProps> = ({ status }) => {
  let color = '';
  let name = '';

  switch (status) {
    case 'order':
      name = 'Bán hàng';
      color = '#108ee9';
      break;
    case 'return':
      name = 'Trả hàng';
      color = '#f50';
      break;
  }
  return <Tag color={color}>{name}</Tag>;
};

export default OrderTypeRender;
